$('.js-pf-item').click(function H(e) {
    $(this).toggleClass("active");
});

$('.js-pf-btn').on('click', function(e) {
    e.preventDefault();

    let fieldKey = 'user_preferences'; // Replace with your ACF field key
    let value = ''; // Replace with the value you want to set
    let userEmail = $(this).data('value'); // Replace with the value you want to set
    $('.js-pf-item.active').each(function() {
        value += $(this).data('title') + ", ";
    });

    // Remove the trailing comma
    value = value.slice(0, -2);


    $.ajax({
        url: ajaxurl,
        type: 'post',
        data: {
            action: 'update_user_acf_field',
            field_key: fieldKey,
            value: value,
            user_email: userEmail,
        },
        success: function(response) {
            location.reload();
            // Handle success response
            console.log('Field updated successfully');
        },
        error: function(xhr, status, error) {
            // Handle error response
            console.error('Error updating field:', error);
        }
    });
});

document.addEventListener( 'wpcf7mailsent', function( event ) {
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const cookieValue = getCookie('test');
    dl.log(cookieValue);

    setTimeout(function () {
        if(cookieValue) {
            window.location.reload();
        }
    }, 500)
}, false );
